import {cookies} from "../utils/cookies";

export const rowsPerPageOptions = [5, 10, 25, 50, 100];
export const defaultPageSize = parseInt(cookies.get('pageSize')) || 10;
export const defaultPage = 0;